export default {
    BASE_URL: '/pam/activity',
    api: [
        {
            name: 'dataList',
            desc: '活动管理列表',
            method: 'GET',
            path: '/manage/data/list',
            params: {
                pageSize: 25,
                pageNum: 1,
                dataStatus: '',
                editName: '',
                activityName: '',
                beginStartDate: '',
                finishStartDate: '',
                beginEndDate: '',
                finishEndDate: '',
                activityEnable: '',
                orderBy:0,
                orderType:2
            }
        },
        {
            name: 'add',
            desc: '添加活动',
            method: 'POST',
            path: '/manage/add',
            param:{
                activityCode:'',
                activityType:'',
                activityName:'',
                startDate:'',
                endDate:'',
                remarks:'',
                prods:[],
                prizeList:[]
            }
        },
        {
            name: 'prods',
            desc: '获取商品列表',
            method: 'GET',
            path: '/manage/prods/list',
            param:{
                pageNum:1,
                pageSize:25,
                actName:''
            }
        },
        {
            name: 'activityDetail',
            desc: '获取活动详情',
            method: 'GET',
            path: '/manage/detail',
            param:{
                id:''
            }
        },
        {
            name: 'enable',
            desc: '上下线',
            method: 'POST',
            path: '/manage/enable',
            param:{
                id:'',
                hasEnable:''
            }
        },
        {
            name: 'delete',
            desc: '删除活动',
            method: 'POST',
            path: '/manage/delete',
            param:{
                id:'',
                hasEnable:''
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/apis/pam/activity.js